var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"code-block"},[(_vm.url)?_c('a',{attrs:{"href":_vm.url,"target":_vm.sampleName}},[_vm._v("查看示例源码")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }